<template>
    <div class='text_box'>
        <div class="title">用户充值协议</div>
        <div>尊敬的用户您好，在同意本协议前，请您认真阅读并充分知悉、理解{{ name }}平台的各项规则及要求，以及国家关于该类互联网信息服务的法律法规等。如果您对本协议的任何条款表示异议，您可以选择不使用；使用则意味着您将同意遵守本协议下全部规定，以及我们后续对使用协议随时所作的任何修改，并完全服从于我们的统一管理。本协议已对与您的权益有或可能具有重大关系的条款，及对{{ name }}平台具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。</div>
        <div>请确认您具有完全民事行为能力，如您已年满18周岁，或您已年满16周岁且依靠自己的劳动收入作为主要生活来源，否则请您停止注册或使用本协议项下的服务。</div>
        <div>
            <h2>第一章 总则</h2>
            <ul>
                <li>1.{{ name }}平台是成都市艺苑网络科技有限公司(以下统称“{{ name }}官方”) 向用户提供的一种更方便的进行视频直播、观看视频直播服务并与用户进行互动的互联网信息服务平台。{{ name }}平台将为用户提供虚拟礼物、技术支持、流量入口等进行视频社交所需的服务。</li>
                <li>2.{{ name }}平台所有权、经营权、管理权均属{{ name }}官方。</li>
                <li>3.{{ name }}官方有权在法律允许的范围内对本协议进行修改。</li>
            </ul>
        </div>
        <div>
            <h2>第二章 “{{ currency }}”购买规则</h2>
            <ul>
                <li>1.“{{ currency }}”是{{ name }}官方向您提供的用于在{{ name }}平台上进行相关消费的虚拟货币，您可以用“{{ currency }}”自由购买虚拟礼物等{{ name }}平台上各项产品或服务。您可将购买的虚拟礼物赠与主播。但是，“{{ currency }}”不能兑换为人民币，您应根据自己的实际需求购买相应数量的“{{ currency }}”。</li>
                <li>2.“人民币”购买“{{ currency }}”的规则（包括但不限于兑换比例）以您充值时{{ name }}平台即时公布或展示的规则为准。{{ name }}平台有权根据相关法律规定、主管部门要求、业务开展情况等因素对使用人民币购买“{{ currency }}”的规则进行单方面变更、调整、中止或终止的权利。您可以选择即时终止购买行为，否则视为同意接受对上述购买规则的生效、变更、调整、中止或终止。</li>
                <li>3.在进行充值时，您务必仔细确认自己的账号并仔细选择相关操作选项。若因为您自身输入账号错误、操作不当或不了解充值计费方式等非{{ name }}平台因素造成充错账号、错选充值种类等情形的，{{ name }}平台将不予退费，也不会作出任何补偿或赔偿。</li>
                <li>4.若您以不正当的方式，或使用非{{ name }}平台所指定的充值方式进行充值，{{ name }}平台不保证该充值顺利或者正确完成。若因此造成您权益受损，{{ name }}平台不会作出任何补偿或赔偿。因您采取不正当方式（包括但不限于利用{{ name }}系统漏洞、通过非{{ name }}认可渠道、违反规则、利用外挂程序、作弊等方式）进行充值，损害了{{ name }}平台及其他方的合法权益，{{ name }}平台有权随时没收、冻结不当所得，封禁您的{{ name }}账号及禁止您使用各项充值服务的权利。</li>
                <li>5.充值成功后，充值所增加的账号内“{{ currency }}”可由您在{{ name }}平台上自由使用，但{{ name }}平台在任何情况下都不会提供任何退还或逆向兑换服务。</li>
                <li>6.如果{{ name }}平台发现因系统故障或其他任何原因导致的处理错误，无论有利于{{ name }}平台还是有利于您，{{ name }}平台都有权在以电子邮件、微信或其他合理方式通知您后纠正该错误。如果该措施导致您实际收到的“{{ currency }}”数量少于您应获得的“{{ currency }}”，则{{ name }}平台在确认该处理错误后会尽快将差额补足至您的{{ name }}账户中。如果该错误导致您实际收到的“{{ currency }}”数量多于您应获得的“{{ currency }}”，则无论错误的性质和原因如何，{{ name }}平台有权从您的{{ name }}账户中直接扣除差额。</li>
            </ul>
        </div>
        <div>
            <h2>第三章 权利声明</h2>
            <li>1.您可随时在手机APP上查看您的“{{ currency }}”的余额情况。如您对该记录有异议，应立即向{{ name }}平台提出，{{ name }}平台核对后确有错误的，将予以更正；否则您同意{{ name }}平台上的交易记录将作为“{{ currency }}”交易的唯一有效依据。</li>
            <li>2{{ name }}平台有权基于交易安全等方面的考虑不时设定涉及交易的相关事项，包括但不限于交易限额、交易次数等。您了解，{{ name }}平台的前述设定可能对您的交易造成一定不便，您对此没有异议。</li>
            <li>3.在任何情况下，对于您购买“{{ currency }}”时涉及由第三方提供相关服务的责任由该第三方承担，{{ name }}平台不承担该等责任。</li>
            <li>4.进行充值时，您应确保您是绑定的支付宝等账户持有人，可合法、有效使用该账户且未侵犯任何第三方合法权益，否则因此造成支付宝等账户实际所有人损失的，您应单独负责解决由此产生的纠纷并承担全部法律责任。</li>
            <li>5.因您自身的原因导致{{ name }}平台无法提供“{{ currency }}”购买服务或提供“{{ currency }}”购买服务时发生任何错误而产生的任何损失或责任，由您自行负责，{{ name }}平台不承担责任，包括但不限于
                <ul>
                    <li>（1）您未按照本协议或{{ name }}平台不时公布的任何规则进行操作；</li>
                    <li>（2）因您的{{ name }}账号失效、丢失、被封禁；</li>
                    <li>（3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；</li>
                    <li>（4）您将密码告知他人导致的财产损失；</li>
                    <li>（5）因您个人的故意或重大过失所造成的财产损失。</li>
                </ul>
            </li>
            <li>6.{{ name }}平台系统因下列状况无法正常运作，使您无法使用各项服务或任何虚拟财产丢失时，本团队不承担损害赔偿责任，该状况包括但不限于：
                <ul>
                    <li>（1）在{{ name }}平台公告之系统停机维护、升级、调整期间；</li>
                    <li>（2）电信通讯或设备出现故障不能进行数据传输的；</li>
                    <li>（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成{{ name }}平台系统障碍不能执行业务的；</li>
                    <li>（4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。</li>
                </ul>
            </li>
        </div>
        <div>
            <h2>第四章 处罚规则</h2>
            <ul>
                <li>1.如发生下列任何一种情形，{{ name }}平台有权随时中断或终止向您提供本协议项下的网络服务而无需通知您：
                    <ul>
                        <li>（1）您提供的个人资料不真实；</li>
                        <li>（2）您违反本协议中规定的购买规则；</li>
                        <li>（3）您违反{{ name }}另行公布的活动规则、要求等。</li>
                    </ul>
                </li>
                <li>除前款所述情形外，{{ name }}平台同时保留在不事先通知您的情况下随时中断或终止部分或全部网络充值服务的权利，对于充值服务的中断或终止而造成的任何损失，{{ name }}平台无需对您或任何第三方承担任何责任。</li>
                <li>如果用户违规使用非本人苹果手机应用商店代冲值，或者通过其它非{{ name }}平台认可的渠道非法购买{{ currency }}，则{{ name }}平台有权冻结该账户，并进行相应惩罚，严重者可以进行封号处理。</li>
                <li>2.用户在使用{{ name }}平台时，如出现违反国家法律法规，本协议约定或其他{{ name }}平台对用户的管理规定的情形，{{ name }}平台有权暂时或永久封禁您的账号。账号封禁后至解禁（如有）前，您账户上的剩余“{{ currency }}”将被暂时冻结或全部扣除，不可继续用于购买平台上的虚拟产品或服务，同时不予返还您购买“{{ currency }}”时的现金价值。</li>
            </ul>
        </div>
        <div>
            <h2>第五章 附则</h2>
            <ul>
                <li>1.本协议可由{{ name }}随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本平台查阅最新版协议条款。在{{ name }}修改协议条款后，如果用户不接受修改后的条款，请立即停止使用，若用户继续使用将被视为接受修改后的协议。</li>
                <li>2.因本协议引起的或与本协议有关的争议，均适用中华人民共和国法律。</li>
                <li>3.因本协议引起的或与本协议有关的争议，{{ name }}平台与您将协商解决。协商不成的，任何一方均有权向本协议签订地有管辖权的法院提起诉讼。</li>
                <li>4本协议部分内容被有管辖权的法院认定为违法或无效的，不因此影响其他内容的效力。</li>
                <li>5.本协议未涉及的问题参见国家有关法律法规，当本协议与国家法律法规冲突时，以国家法律法规为准。</li>
                <li>6.本协议签订地：成都。</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RechargeAgreement',
    data() {
        return {
            name: '随风直播',
            currency: '随风币'
        }
    },
    created() {
        document.title = "用户充值协议"
        this.name = this.$common.GetQueryString('name') ? this.$common.GetQueryString('name') : '随风直播'
        this.currency = this.$common.GetQueryString('currency') ? this.$common.GetQueryString('currency') : '随风币'
    }
}
</script>

<style scoped>
    body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,label,dl,dt,dd,fieldset {margin:0;padding:0;}
    ul,ol,li {list-style:none;}
    .title{line-height:30px !important;margin-top:10px !important;color:#3f3f3f !important;font-size:18px !important;font-weight:700 !important; text-align: center;}
    table{border-collapse:collapse;border-spacing:0;}
    img {border:none;}
    input,img,select {vertical-align:middle;}
    body,fieldset,th,td,select,input,textarea {font-family:"微软雅黑",Arial,Helvetica,sans-serif; color:#666;}
    select,input {vertical-align:middle;}
    cite,em {font-style:normal;}
    .wordwrap {word-wrap:break-word;word-break:break-all;}

    a:link,a:visited,a:hover,a:active {text-decoration:none;}
    .text_box{ padding:20px;}
    .text_box div{ color:#000; line-height:24px;}
    .text_box h2{ font-size:16px;}
    h2{margin: 10px 0;}
</style>
